import { HeroPrimary } from "../headers/HeroPrimary";
import { SectionBlockMediaFeatured } from "../sections/blocks/SectionBlockMediaFeatured";
import { SectionBlockMediaCTA } from "../sections/blocks/SectionBlockMediaCTA";
import { SectionBlockStats } from "../sections/blocks/SectionBlockStats";
import WrenchIcon from "~/assets/svgs/icons/WrenchIcon";
import { HardHatIcon } from "~/assets/svgs/icons/HardHatIcon";
import { LinkIcon } from "~/assets/svgs/icons/LinkIcon";
import { GearFlagIcon } from "~/assets/svgs/icons/GearFlagIcon";
import { WrapperComponents } from "../wrappers/WrapperComponents";
import { SectionCardCarousel } from "../sections/blocks/SectionCardCarousel";
import { SectionBlockPinnedMediaItems } from "../sections/blocks/SectionBlockPinnedMediaItems";
import { CardTile } from "../components/cards/CardTile";
import { Inducted } from "~/assets/svgs/icons/Inducted";
import { Connector } from "~/assets/svgs/icons/Connector";
import { Asist } from "~/assets/svgs/icons/Asist";
import { CasesManaged } from "~/assets/svgs/icons/CasesManaged";
import { SectionBlockStatsAlt } from "../sections/blocks/SectionBlockStatsAlt";
import { SectionBlockCallout } from "../sections/blocks/SectionBlockCallout";
import { SectionBlockMediaItem } from "../sections/blocks/SectionBlockMediaItem";
import { CardCarousel } from "../components/cards/CardCarousel";

export interface ITemplatePageAbout {
  data: any;
}

export default function TemplatePageAbout({ data }: ITemplatePageAbout) {
  const {
    heroPrimary,
    sectionBlockCallout,
    sectionBlockPinnedMediaItems,
    sectionBlockStatsAlt,
    callToAction,
    sectionBlockCardCarousel,
  } = data;

  // console.log("templatePageAbout", data);
  return (
    <>
      {heroPrimary && <HeroPrimary data={heroPrimary} />}

      <WrapperComponents>
        {sectionBlockCallout && (
          <SectionBlockCallout data={sectionBlockCallout} theme="colour" />
        )}
        {sectionBlockPinnedMediaItems && (
          <SectionBlockPinnedMediaItems data={sectionBlockPinnedMediaItems} />
        )}
        {sectionBlockStatsAlt && (
          <SectionBlockStatsAlt data={sectionBlockStatsAlt} />
        )}
        {sectionBlockCardCarousel &&
          sectionBlockCardCarousel.items.length > 0 && (
            <SectionCardCarousel
              theme="colour"
              data={{
                text: sectionBlockCardCarousel.text,
                title: sectionBlockCardCarousel.title,
                link: sectionBlockCardCarousel.link,
              }}
            >
              {Array.isArray(sectionBlockCardCarousel.items) &&
                sectionBlockCardCarousel.items.map(
                  (item: any, index: number) => (
                    <CardCarousel
                      heightFull
                      theme="light"
                      card={{
                        title: item.title,
                        text: item.text,
                      }}
                      key={index}
                      index={index + 1}
                    />
                  ),
                )}
            </SectionCardCarousel>
          )}
        {callToAction && <SectionBlockMediaItem data={callToAction} />}
      </WrapperComponents>
    </>
  );
}
